export default {"src":"/_next/static/media/aside-arrow.bd0f498b.svg","height":12,"width":24,"blurWidth":0,"blurHeight":0};